export  enum Apartments_Types  {
  villa = "villa",
  break = "break",
  apartment = "apartment",
  studio="studio",
  chalet = "chalet",
  hut = "hut",
  room = "room"
}
export  enum ApartmentsTypes_EN  {
  villa = "villa",
  break = "break",
  apartment = "apartment",
  studio="studio",
  chalet = "chalet",
  hut = "hut",
  room = "room"
}
export  enum ApartmentsTypes_AR {
  villa = "فيلا",
  break = "استراحة",
  apartment = "شقة",
  studio="استوديو",
  chalet = "شاليه",
  hut = "كوخ",
  room = "غرفة"
}
export const ApartmentsTypesOption = [
  {ar: ApartmentsTypes_AR.villa,en: ApartmentsTypes_EN.villa},
  {ar: ApartmentsTypes_AR.break,en: ApartmentsTypes_EN.break},
  {ar: ApartmentsTypes_AR.apartment,en: ApartmentsTypes_EN.apartment},
  {ar: ApartmentsTypes_AR.studio,en: ApartmentsTypes_EN.studio},
  {ar: ApartmentsTypes_AR.chalet,en: ApartmentsTypes_EN.chalet},
  {ar: ApartmentsTypes_AR.hut,en: ApartmentsTypes_EN.hut},
  {ar: ApartmentsTypes_AR.room,en: ApartmentsTypes_EN.room},
]